import { DeltaBadge, DonutChart } from "../primitives";
import { FunnelStage } from "./types";
import styles from "./style.module.scss";

interface FunnelRingsProps {
  stages: FunnelStage[];
  format?: (value: number) => string;
}

/** Ring view: a 2x2 grid of small donuts, one per stage. */
function FunnelRings({ stages, format }: FunnelRingsProps) {
  const toText = format ?? ((value: number) => value.toLocaleString("en-US"));

  return (
    <div className={styles.rings}>
      {stages.map((stage) => (
        <div key={stage.key} className={styles.ringCard}>
          <DonutChart
            size={56}
            thickness={12}
            rounded
            trackColor="#eee6ef"
            slices={[{ label: stage.label, share: stage.share, color: stage.color }]}
            center={
              <span className={styles.ringPct}>{`${Math.round(stage.share)}%`}</span>
            }
          />
          <div className={styles.ringBody}>
            <div className={styles.ringLabel}>{stage.label}</div>
            <div className={styles.ringValue}>{toText(stage.value)}</div>
            <DeltaBadge delta={stage.delta} bare size="xs" hideAgainst />
          </div>
        </div>
      ))}
    </div>
  );
}

export default FunnelRings;
